type GQLType<S extends string = string> = { __typename: S }

export const isGQLType = <T extends GQLType, K extends T['__typename']>(k: K, t: T): t is T & GQLType<K> => {
  return t.__typename === k
}
